/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import Switch from 'DesignSystem/Svgs/Switch/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Actions/Choose/SwitchImages/Content"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginBottom="auto"
 onClick={onClick}
 marginLeft={16}
 marginRight={16}
>
{childProps => (
<Switch
{...childProps}
  viewPath={`${viewPath}/Switch`}
 width={12}
 height={12}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}